// @ts-nocheck
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import StoreProductDetailsInformationImages from "@store/Library/Widgets/ProductDetailsVariant/StoreProductDetailsInformationImages";
import React from "react";

const enum fieldsEnum {
    attributes = "attributes",
    attributeName = "attributeName",
    fallbackOnNormalAttributeType = "fallbackOnNormalAttributeType",
}

export type AttributeModel = {
    fields: {
        [fieldsEnum.attributeName]: string;
    };
};

interface OwnProps extends WidgetProps {
    fields: {
        [fieldsEnum.attributes]: AttributeModel[];
        [fieldsEnum.fallbackOnNormalAttributeType]: boolean;
    };
}

const ProductDetailsInformationImages: React.FC<OwnProps> = ({ fields }) => {
    return (
        <StoreProductDetailsInformationImages
            selectedAttributes={fields.attributes?.map(x => x.fields[fieldsEnum.attributeName]) || []}
            fallbackOnNormalAttributeType={fields.fallbackOnNormalAttributeType}
        />
    );
};

const widgetModule: WidgetModule = {
    component: ProductDetailsInformationImages,
    definition: {
        group: "Product Details",
        displayName: "Product Details Information Images",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fieldsEnum.attributes,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.attributeName;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: fieldsEnum.attributeName,
                        displayName: "Tap the attribute you want to display",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
            {
                name: fieldsEnum.fallbackOnNormalAttributeType,
                displayName: "Fallback on the normal attribute types order if the one selected are not found",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
